import type { LucideIcon } from 'lucide-react';
import {
  BarChart3,
  Bot,
  Braces,
  CalendarClock,
  Circle,
  CirclePlay,
  Cloud,
  Cpu,
  Database,
  FileText,
  Flag,
  Gem,
  GitBranch,
  GitMerge,
  Globe,
  Hourglass,
  LayoutGrid,
  ListTree,
  Mail,
  MessageSquare,
  MessageSquareMore,
  Package,
  Plus,
  RefreshCcw,
  Search,
  ShieldAlert,
  Shuffle,
  Sparkles,
  Split,
  SunMedium,
  Target,
  Terminal,
  Trash2,
  Users,
  Waypoints,
  Webhook,
  Wrench,
  Zap,
} from 'lucide-react';

/** Icons referenced by workflow builder API (`lucide:<ExportName>`). Extend when backend adds palette rows. */
const LUCIDE_BY_NAME: Record<string, LucideIcon> = {
  BarChart3,
  Bot,
  Braces,
  CalendarClock,
  CirclePlay,
  Cloud,
  Cpu,
  Database,
  FileText,
  Flag,
  Gem,
  GitBranch,
  GitMerge,
  Globe,
  Hourglass,
  LayoutGrid,
  ListTree,
  Mail,
  MessageSquare,
  MessageSquareMore,
  Package,
  Plus,
  RefreshCcw,
  Search,
  ShieldAlert,
  Shuffle,
  Sparkles,
  Split,
  SunMedium,
  Target,
  Terminal,
  Trash2,
  Users,
  Waypoints,
  Webhook,
  Wrench,
  Zap,
};

const FALLBACK: LucideIcon = Circle;

export function lucideIconFromRef(ref: string | undefined | null): LucideIcon {
  if (!ref || typeof ref !== 'string') return FALLBACK;
  if (!ref.startsWith('lucide:')) return FALLBACK;
  const name = ref.slice('lucide:'.length);
  return LUCIDE_BY_NAME[name] ?? FALLBACK;
}
